<script>
import BasePreview from './../BasePreview'

export default {
   extends: BasePreview,
   methods: {
      getImageStyle(zone) {
         let transformScale = '';
         if (zone.scaleX < 0) {
            transformScale += ' scaleX(-1)';
         }
         if (zone.scaleY < 0) {
            transformScale += ' scaleY(-1)';
         }

         return 'left: ' + zone.assetX + 'px; top: ' + zone.assetY + 'px; width: ' + zone.assetW * Math.abs(zone.scaleX) + 'px; transform: rotate(' + zone.rotation + 'deg) '  + transformScale + ';';
      }
   }
}

</script>